import banner from '../assets/banner.jpg'

export default function Cover() {
  return <img src={banner} alt="banner" style={{width: '100%', height: 'auto', marginTop: '30px'}} />
}